import { Card, CardBody, Stack, Text } from '@chakra-ui/react';
import { Show } from '@pelicargo/ui';

import { useCurrentDraft } from '../../../hooks/useCurrentDraft';
import { AppliedSummary } from './AppliedSummary';
import { LinkageCard } from './LinkageCard';
import { readApplySummary, readBookingPayload } from './payload';
import { ReviewAlerts } from './ReviewAlerts';
import { SegmentsTable } from './SegmentsTable';

/**
 * Review view for a booking-confirmation draft: what the deterministic matcher resolved the email to — which request,
 * carrier and quote — and which flights the carrier confirmed, each labelled against the quote's own flight path.
 * Which legs an apply would fill or reroute is already in the table's tags, so nothing here restates it. Once applied,
 * what it wrote is marked orange, and its record closes the section.
 */
export const BookingConfirmationSection = () => {
  const { draft } = useCurrentDraft();
  if (!draft) return null;

  const booking = readBookingPayload(draft.payload);
  const applied = readApplySummary(draft.applied_summary);
  const hasFilledFlights = !!applied?.filledCount;

  return (
    <Stack spacing="4">
      <LinkageCard booking={booking} applied={applied} />

      <Show if={!!booking && booking.segments.length > 0}>
        <Card variant="outline">
          <CardBody px="0" py="2">
            <SegmentsTable segments={booking?.segments ?? []} isFilled={hasFilledFlights} />
          </CardBody>
        </Card>
      </Show>

      <Show if={!!booking?.notes}>
        <Text fontSize="sm" color="gray.600">
          {booking?.notes}
        </Text>
      </Show>

      <ReviewAlerts booking={booking} />

      <Show if={!!applied}>
        <AppliedSummary applied={applied} />
      </Show>
    </Stack>
  );
};
